import { useState, useEffect, useCallback } from 'react'
import { preseaApi } from '../../api/presea'
import Boton from '../../components/Boton'
import { syncPillStyle, resumirSync, fmtFecha, st } from './_common'

/**
 * Sincronización de maestros desde Presea por FTP (clientes / artículos / precios /
 * cta cte / movimientos / deudores). Cron diario 05:30 ART; este botón fuerza el sync.
 * Dividida de PreseaPage 24/06/26.
 */
export default function PreseaMaestros() {
  const [syncs, setSyncs] = useState([])
  const [ftpInfo, setFtpInfo] = useState(null)
  const [sincronizando, setSincronizando] = useState(false)
  const [salida, setSalida] = useState('')
  const [error, setError] = useState('')

  const cargar = useCallback(async () => {
    try {
      const { data } = await preseaApi.sincronizaciones()
      setSyncs(data.data || [])
      setFtpInfo({ fake: data.ftp_fake, configurado: data.ftp_configurado })
    } catch { /* la card muestra vacío */ }
  }, [])

  useEffect(() => { cargar() }, [cargar])

  const sincronizar = async () => {
    setSincronizando(true); setSalida(''); setError('')
    try {
      const { data } = await preseaApi.sincronizarMaestros()
      setSalida(data?.salida || '(sin salida)')
      cargar()
    } catch (e) {
      setError(e.response?.data?.message || 'Error al sincronizar maestros.')
    } finally { setSincronizando(false) }
  }

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto' }}>
      <h2 style={st.title}>ERP Presea — Maestros</h2>
      <p style={st.sub}>
        Clientes, artículos+precios, cta cte, movimientos y deudores se bajan del FTP de Presea y se
        actualizan solos cada día a las 05:00 ART (si el archivo no cambió, no toca nada). Lo creado
        en LGR no se pisa.
      </p>

      <div style={st.card}>
        <div style={st.cardHead}>
          <h3 style={st.cardTitle}>Sincronización por FTP</h3>
          <Boton variante="send" onClick={sincronizar} disabled={sincronizando || !ftpInfo?.configurado}
            title={!ftpInfo?.configurado ? 'Falta configurar PRESEA_FTP_HOST/USER/PASS' : ''}>
            {sincronizando ? 'Sincronizando…' : '⇣ Sincronizar ahora'}
          </Boton>
        </div>
        {ftpInfo?.fake && (
          <p style={st.muted}>
            <strong>Modo simulación activo</strong> (PRESEA_FTP_FAKE=true): lee de <code style={st.code}>storage/app/presea-ftp-fake/</code>.
          </p>
        )}
        {!ftpInfo?.configurado && (
          <p style={st.muted}>FTP no configurado. Definí <code style={st.code}>PRESEA_FTP_HOST/USER/PASS</code> en el .env.</p>
        )}

        {syncs.length === 0 ? (
          <p style={st.muted}>Sin sincronizaciones todavía.</p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={st.tabla}>
              <thead>
                <tr>
                  {['Cuándo', 'Tipo', 'Archivo', 'Estado', 'Resumen'].map(h => (
                    <th key={h} style={st.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {syncs.map(s => (
                  <tr key={s.id} style={st.tr}>
                    <td style={{ ...st.td, whiteSpace: 'nowrap' }}>{fmtFecha(s.created_at)}</td>
                    <td style={st.td}><code style={st.code}>{s.tipo}</code></td>
                    <td style={st.td}><code style={st.code}>{s.archivo}</code></td>
                    <td style={st.td}><span style={{ ...st.pillSm, ...syncPillStyle(s.estado) }}>{s.estado.replace('_', ' ')}</span></td>
                    <td style={st.td}>
                      {s.estado === 'error'
                        ? <span style={{ color: '#991b1b' }}>{s.error}</span>
                        : s.resumen ? resumirSync(s.resumen) : '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {salida && (
          <div style={st.salidaProceso}>
            <strong>Salida del comando:</strong>
            <pre style={st.jsonBox}>{salida}</pre>
          </div>
        )}
      </div>

      {error && <p style={st.errorMsg}>{error}</p>}
    </div>
  )
}
